const getSelectValue = (value) => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }
  return value.value;
};

export default getSelectValue;
